import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Content } from 'antd/es/layout/layout';

import englan from '../english.json';
import germanlan from '../german.json';
import arabiclan from '../arabic.json';
import frenchlan from '../french.json';
import hindilan from '../hindi.json';
import malayalamlan from '../malayalam.json';

export default function WebsocketConnectionError () {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;


	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
		

	const navigate = useNavigate();
    
	return (
		<Content>
			<Result
				style={{ marginTop : '100px'}}
				status="500"
				title=""
				subTitle={langdata && langdata.Sorrywebsocketconnectionerror && langdata.Sorrywebsocketconnectionerror ? langdata.Sorrywebsocketconnectionerror : 'Sorry, websocket connection error.'}
				extra={<Button type="primary" onClick={() => {navigate('/dashboard');}}>
					{langdata && langdata.Backtodashboard && langdata.Backtodashboard ? langdata.Backtodashboard : 'Back to Dashboard'}
				</Button>}
			/>
		</Content>
	);
}
